<template>
  <div>
    <BreadCrumbs />
    <HoverBox id="f" />
    <SuccessCase />
    <Client />
  </div>
</template>

<script>
import BreadCrumbs from "@/components/home/breadCrumbs";
import HoverBox from "@/components/home/foreignCompanyService/siderContent-01";
import SuccessCase from "@/components/home/foreignCompanyService/siderContent-02";
import Client from "@/components/home/foreignCompanyService/siderContent-04";
import { mixin } from "@/mixin/mixin.js";
export default {
  name: "translation-service",
  components: {
    BreadCrumbs,
    HoverBox,
    SuccessCase,
    Client,
  },
  data() {
    return {};
  },
  mixins: [mixin],
};
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/home/foreignCompanyService/index.vue